import ApiClient from './ApiClient';

// Must match TOBController's LANGUAGE_* values on the backend.
export const TOB_LANGUAGES = ['English', 'Bahasa Indonesia'];
export const DEFAULT_TOB_LANGUAGE = 'English';

export const fetchTOBBenefits = ({ planIds, language = DEFAULT_TOB_LANGUAGE, token }) => {
  return ApiClient.post(
    '/api/quotations/tob/benefits',
    { plan_ids: planIds, language },
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};
